import { createReducer } from 'utils/ReduxUtils';

import { LOCATION_CHANGE } from './actionTypes';
import type { LocationChangeAction, RouterState } from './types';

const PREVIOUS_LOCATIONS_TO_KEEP = 10;

const initialState: RouterState = {
  location: null,
  action: null,
  previousLocations: [],
};

const onLocationChange = (state: RouterState, { payload }: LocationChangeAction): RouterState => {
  const { location, action } = payload;

  return {
    ...state,
    location,
    action,
    previousLocations: [{ location, action }, ...state.previousLocations.slice(0, PREVIOUS_LOCATIONS_TO_KEEP - 1)],
  };
};

export default createReducer(initialState, {
  [LOCATION_CHANGE]: onLocationChange,
});
